module.exports = __webpack_public_path__ + "img/auth-bg.5d0f0ddd.jpg";